import React from "react";
import styled from "styled-components";
import SyntaxHighlighter from "react-syntax-highlighter";
import { github as syntaxHighlighterStyle } from "react-syntax-highlighter/dist/esm/styles/hljs";

const Wrapper = styled.div`
  border-radius: 4px;
  max-width: 100%;
  margin: 30px auto;
`;

const Section = styled.div`
  padding: 10px 0;
`;

const customSyntaxHighlightStyle = {
  "border-radius": "3px",
  padding: "1em",
};

const Usage = () => {
  const code =
    "import { IconTruckDryvan } from '@loadsmart/icons'\n\n<IconTruckDryvan role=\"img\" width={42} height={42} />";

  return (
    <Wrapper>
      <Section>
        <h2>Installation</h2>
        <SyntaxHighlighter
          language="bash"
          style={syntaxHighlighterStyle}
          customStyle={customSyntaxHighlightStyle}
        >
          {"yarn add @loadsmart/icons"}
        </SyntaxHighlighter>
      </Section>

      <Section>
        <h2>Usage</h2>
        <SyntaxHighlighter
          language="javascript"
          style={syntaxHighlighterStyle}
          customStyle={customSyntaxHighlightStyle}
        >
          {code}
        </SyntaxHighlighter>
      </Section>
    </Wrapper>
  );
};

export default Usage;
